const EmptyCompnent = () => {
  return <></>;
};

export default EmptyCompnent;
